import React from 'react';
import Card from '../Card';
import industriesData from '../../data/industries-data';

export default () => (
  <section id="industries" className="py-20 lg:pb-20 lg:pt-20">
    <div className="bg-primary py-12">
      <div className="container mx-auto text-center">
        <h2 className="text-3xl lg:text-5xl font-semibold text-white">Industries</h2>
        <p className="text-xl lg:text-2xl mt-6 font-light text-white">
          Specialized expertise for your industry
        </p>
      </div>
    </div>
    <div className="container mx-auto text-center">
      <div className="flex flex-col flex-wrap sm:flex-row sm:-mx-3 mt-12">
        {industriesData.map(industry => (
          <div key={industry.slug} className="flex flex-1 md:flex-none md:w-1/3 px-3">
            <div className="flex w-full text-black mb-8">
              <Card className="w-full">
                <h3 className="font-semibold text-xl">{industry.title}</h3>
                <p className="mt-4">{industry.description}</p>
              </Card>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);
